const waitFor = async (testFn) =>
  new Promise((resolve) => {
    let attempts = 0;

    const interval = setInterval(() => {
      if (++attempts > 50)
        throw new Error(
          'isomorphic-helpers.waitFor took longer than 10 seconds'
        );

      if (testFn()) {
        clearInterval(interval);
        resolve();
      }
    }, 200);
  });
module.exports = waitFor;
